
    import {
        defineComponent,
    } from 'vue';
    import { EmiratesFilter, isEmiratesAvailable } from '@features/tourProduct/filterTourProducts';
    import MealsFilterDropdown from '@ve/components/filters/mealsFilter/desktop/MealsFilterDropdown.vue';
    import OperatorsFilterHotel from '@ve/components/filters/operatorsFilter/desktop/OperatorsFilterHotel.vue';
    import ProductTypeFilter from '@ve/components/filters/productTypeFilter/desktop/ProductTypeFilter.vue';
    import DatesTabs from '@ve/components/hotel/datesTabs/desktop/DatesTabs.vue';
    import { type FilerProductType } from '@ve/components/hotel/filters/common/store/types';
    import AdditionalFiltersHotel from './AdditionalFiltersHotel.vue';
    import useHotelPageFilters from './use/useHotelPageFilters';

    export default defineComponent({
        name: 'HotelPageFilters',
        components: {
            DatesTabs,
            ProductTypeFilter,
            OperatorsFilterHotel,
            MealsFilterDropdown,
            AdditionalFiltersHotel,
            EmiratesFilter,
        },
        setup() {

            const { resetAdditionalFilters, selectProductTypeFilter } = useHotelPageFilters();

            const handleSelectProductTypeFilter = (type: FilerProductType) => {
                selectProductTypeFilter(type);
                if (type === 'railwayTour' || type === 'hotelOffer') {
                    resetAdditionalFilters();
                }
            }

            return {
                ...useHotelPageFilters(),
                isEmiratesAvailable,
                handleSelectProductTypeFilter,
            };
        },
    });
